import React from 'react';

import { inspectionAPI } from 'api/requests';

import FilePicker from 'Components/FilePicker';

export default function ReportDocumentation({documents, id, user, inspectionModelYear}) {

  if (!user.isInternal() && !user.isInspector())
    return (
      <section className='scene_section'
        onClick={()=> {
          user.goTo(user.getDocumentsLink(
            {
              chosenYear:inspectionModelYear,
              filter:{typeTitle: 'Inspection Report'}
            }
          ));
        }}>
        <header className='_cursor_pointer _flex _ai_center'>
          Please click here to access Inspection Report Documentation.
          <div className='ect-file-picker__col_name_icon _width_20 _height_20 _margin_left_10' />
        </header>
      </section>
    );

  return (
    <section className='scene_section'>
      <header>Inspection Report Documentation</header>
      <div className='__main-alert-label'>
      Please upload inspection report and signature page
      </div>
      <FilePicker
        editableStateSectionHeader=''
        notEditableStateSectionHeader=''
        isEditable={false}
        sectionHeaderClassName='_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16'
        mainWrapperClassName='_min_height_auto'
        uploadButtonText='Upload'
        httpParams={{currentMethod: inspectionAPI.downloadReportDocument, currentId: id}}
        files={documents || []}
      />
    </section>
  );
}

ReportDocumentation.defaultProps = {
  documents: []
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Report/ReportDocumentation.jsx